"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "wno9e6",
  styles: "margin:0 8px;height:5px;width:10px;"
} : {
  name: "wno9e6",
  styles: "margin:0 8px;height:5px;width:10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90cmlhbmdsZS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPc0IiLCJmaWxlIjoiLi4vLi4vc3JjL3RyaWFuZ2xlL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNvbXBvc2UsIGRlZmF1bHRQcm9wcywgc2V0UHJvcFR5cGVzLCBzZXREaXNwbGF5TmFtZSwgd2l0aFByb3BzIH0gZnJvbSAncmVjb21wb3NlJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJ2Vtb3Rpb24tdGhlbWluZyc7XG5cbmNvbnN0IGJhc2UgPSAoKSA9PiBjc3NgXG4gIG1hcmdpbjogMCA4cHg7XG4gIGhlaWdodDogNXB4O1xuICB3aWR0aDogMTBweDtcbmA7XG5cbmNvbnN0IFRyaWFuZ2xlID0gKHsgY2xhc3NOYW1lLCBjb2xvdXIsIGRpciwgcmFuZG9tSWQgfSkgPT4gKFxuICA8c3ZnIGNsYXNzTmFtZT17Y2xhc3NOYW1lfT5cbiAgICB7ZGlyID09PSAndXAnXG4gICAgICA/IDxwb2x5Z29uIGlkPXtgdXAtJHtyYW5kb21JZH1gfSBwb2ludHM9JzAgNSwgNSAwLCAxMCA1JyBmaWxsPXtjb2xvdXJ9IC8+XG4gICAgICA6IDxwb2x5Z29uIGlkPXtgZG93bi0ke3JhbmRvbUlkfWB9IHBvaW50cz0nMCAwLCA1IDUsIDEwIDAnIGZpbGw9e2NvbG91cn0gLz59XG4gIDwvc3ZnPlxuKTtcblxuY29uc3QgX1RyaWFuZ2xlID0gc3R5bGVkKFRyaWFuZ2xlKWBcbiAke2Jhc2V9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjb21wb3NlKFxuICBzZXREaXNwbGF5TmFtZSgnU3Bpbm5lcicpLFxuICBzZXRQcm9wVHlwZXMoe1xuICAgIGNvbG91cjogUHJvcFR5cGVzLmFueSxcbiAgICBkaXI6IFByb3BUeXBlcy5vbmVPZihbJ3VwJywgJ2Rvd24nXSlcbiAgfSksXG4gIHdpdGhUaGVtZSxcbiAgZGVmYXVsdFByb3BzKHtcbiAgICBkaXI6ICd1cCcsXG4gIH0pLFxuICB3aXRoUHJvcHMoKHsgdGhlbWUsIGNvbG91ciB9KSA9PiAoe1xuICAgIGNvbG91cjogY29sb3VyID8gY29sb3VyIDogdGhlbWUuY29sb3JzLm5ldXRyYWxbMF0sXG4gICAgcmFuZG9tSWQ6IE1hdGguZmxvb3IoTWF0aC5yYW5kb20oKSAqIDEwMDAwMClcbiAgfSkpXG4pKF9UcmlhbmdsZSk7XG4iXX0= */"
};

var base = function base() {
  return _ref;
};

var Triangle = function Triangle(_ref2) {
  var className = _ref2.className,
      colour = _ref2.colour,
      dir = _ref2.dir,
      randomId = _ref2.randomId;
  return (0, _core.jsx)("svg", {
    className: className
  }, dir === 'up' ? (0, _core.jsx)("polygon", {
    id: "up-".concat(randomId),
    points: "0 5, 5 0, 10 5",
    fill: colour
  }) : (0, _core.jsx)("polygon", {
    id: "down-".concat(randomId),
    points: "0 0, 5 5, 10 0",
    fill: colour
  }));
};

var _Triangle = (
/*#__PURE__*/
0, _styledBase.default)(Triangle, {
  target: "ehedemj0"
})(base, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90cmlhbmdsZS9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQmtDIiwiZmlsZSI6Ii4uLy4uL3NyYy90cmlhbmdsZS9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjb21wb3NlLCBkZWZhdWx0UHJvcHMsIHNldFByb3BUeXBlcywgc2V0RGlzcGxheU5hbWUsIHdpdGhQcm9wcyB9IGZyb20gJ3JlY29tcG9zZSc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB3aXRoVGhlbWUgfSBmcm9tICdlbW90aW9uLXRoZW1pbmcnO1xuXG5jb25zdCBiYXNlID0gKCkgPT4gY3NzYFxuICBtYXJnaW46IDAgOHB4O1xuICBoZWlnaHQ6IDVweDtcbiAgd2lkdGg6IDEwcHg7XG5gO1xuXG5jb25zdCBUcmlhbmdsZSA9ICh7IGNsYXNzTmFtZSwgY29sb3VyLCBkaXIsIHJhbmRvbUlkIH0pID0+IChcbiAgPHN2ZyBjbGFzc05hbWU9e2NsYXNzTmFtZX0+XG4gICAge2RpciA9PT0gJ3VwJ1xuICAgICAgPyA8cG9seWdvbiBpZD17YHVwLSR7cmFuZG9tSWR9YH0gcG9pbnRzPScwIDUsIDUgMCwgMTAgNScgZmlsbD17Y29sb3VyfSAvPlxuICAgICAgOiA8cG9seWdvbiBpZD17YGRvd24tJHtyYW5kb21JZH1gfSBwb2ludHM9JzAgMCwgNSA1LCAxMCAwJyBmaWxsPXtjb2xvdXJ9IC8+fVxuICA8L3N2Zz5cbik7XG5cbmNvbnN0IF9UcmlhbmdsZSA9IHN0eWxlZChUcmlhbmdsZSlgXG4gJHtiYXNlfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgY29tcG9zZShcbiAgc2V0RGlzcGxheU5hbWUoJ1NwaW5uZXInKSxcbiAgc2V0UHJvcFR5cGVzKHtcbiAgICBjb2xvdXI6IFByb3BUeXBlcy5hbnksXG4gICAgZGlyOiBQcm9wVHlwZXMub25lT2YoWyd1cCcsICdkb3duJ10pXG4gIH0pLFxuICB3aXRoVGhlbWUsXG4gIGRlZmF1bHRQcm9wcyh7XG4gICAgZGlyOiAndXAnLFxuICB9KSxcbiAgd2l0aFByb3BzKCh7IHRoZW1lLCBjb2xvdXIgfSkgPT4gKHtcbiAgICBjb2xvdXI6IGNvbG91ciA/IGNvbG91ciA6IHRoZW1lLmNvbG9ycy5uZXV0cmFsWzBdLFxuICAgIHJhbmRvbUlkOiBNYXRoLmZsb29yKE1hdGgucmFuZG9tKCkgKiAxMDAwMDApXG4gIH0pKVxuKShfVHJpYW5nbGUpO1xuIl19 */");

var _default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Spinner'), (0, _recompose.setPropTypes)({
  colour: _propTypes.default.any,
  dir: _propTypes.default.oneOf(['up', 'down'])
}), _emotionTheming.withTheme, (0, _recompose.defaultProps)({
  dir: 'up'
}), (0, _recompose.withProps)(function (_ref3) {
  var theme = _ref3.theme,
      colour = _ref3.colour;
  return {
    colour: colour ? colour : theme.colors.neutral[0],
    randomId: Math.floor(Math.random() * 100000)
  };
}))(_Triangle);

exports.default = _default;